import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH } from "@repo/shared";

// Local translations
export const T = {
  en_GB: {
    loading: "Loading...",
    invalidLink: "Invalid link",
    linkExpiredDescription: "This password reset link is invalid or has expired.",
    requestNewLink: "Request new reset link",
    backToLogin: "Back to login",
    passwordReset: "Password reset!",
    passwordResetSuccess: "Your password has been successfully reset.",
    signInWithNewPassword: "Sign in with new password",
    resetPassword: "Reset password",
    enterNewPassword: "Enter your new password below",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    minCharacters: `Minimum ${PASSWORD_MIN_LENGTH} characters`,
    fillAllFields: "Please fill in all fields",
    passwordMinLength: `Password must be at least ${PASSWORD_MIN_LENGTH} characters`,
    passwordMaxLength: `Password must not exceed ${PASSWORD_MAX_LENGTH} characters`,
    passwordsDoNotMatch: "Passwords do not match",
    invalidResetLink: "Invalid reset link. Please request a new one.",
    failedToResetPassword: "Failed to reset password",
  },
  nb_NO: {
    loading: "Laster...",
    invalidLink: "Ugyldig lenke",
    linkExpiredDescription:
      "Denne lenken for tilbakestilling av passord er ugyldig eller har utløpt.",
    requestNewLink: "Be om ny tilbakestillingslenke",
    backToLogin: "Tilbake til innlogging",
    passwordReset: "Passord tilbakestilt!",
    passwordResetSuccess: "Passordet ditt har blitt tilbakestilt.",
    signInWithNewPassword: "Logg inn med nytt passord",
    resetPassword: "Tilbakestill passord",
    enterNewPassword: "Skriv inn ditt nye passord nedenfor",
    newPassword: "Nytt passord",
    confirmPassword: "Bekreft passord",
    minCharacters: `Minimum ${PASSWORD_MIN_LENGTH} tegn`,
    fillAllFields: "Vennligst fyll ut alle felt",
    passwordMinLength: `Passordet må være minst ${PASSWORD_MIN_LENGTH} tegn`,
    passwordMaxLength: `Passordet kan ikke overstige ${PASSWORD_MAX_LENGTH} tegn`,
    passwordsDoNotMatch: "Passordene stemmer ikke overens",
    invalidResetLink: "Ugyldig tilbakestillingslenke. Vennligst be om en ny.",
    failedToResetPassword: "Kunne ikke tilbakestille passord",
  },
} as const;
